import { render } from "./ContentScreenshot.vue?vue&type=template&id=024de1d2&scoped=true"
import script from "./ContentScreenshot.vue?vue&type=script&lang=js"
export * from "./ContentScreenshot.vue?vue&type=script&lang=js"

import "./ContentScreenshot.vue?vue&type=style&index=0&id=024de1d2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src895191040/src/tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024de1d2"]])

export default __exports__